"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function listParse(array) {
    try {
        let a = JSON.parse(array);
        if (a instanceof Array) {
            return a;
        }
        else {
            throw new Error();
        }
    }
    catch (e) {
        return array.toString();
    }
}
exports.default = listParse;
